import { TableColumn } from '../../../../table/interfaces/table';
import { JobObjectFailure } from '../../../interfaces/job';
import { Calendar } from '../../../../shared/components/Calendar/Calendar';
import { JobObjectStageFailureActions } from './JobObjectStageFailureActions';

export const jobObjectStageFailureColumns: TableColumn<JobObjectFailure>[] = [
  {
    id: 'failedTs',
    field: 'failedTs',
    headerName: 'Failed At',
    renderCell: params => (
      <Calendar value={params.row.data.failedTs} options={{ hideZeroTimestamp: true }} />
    ),
    width: 200 // change to 130 when failure count is fixed
  },
  // {
  //   id: 'count',
  //   field: 'count',
  //   headerName: 'Events Failed',
  //   justifyEnd: false,
  //   renderCell: params => <RenderEventCell showHyphenOnZero count={params.row.data.count} />,
  //   width: 150
  // },
  {
    id: 'reason',
    field: 'reason',
    headerName: 'Reason',
    renderCell: params => <span>{params.row.data.reason}</span>,
    width: 350, // change to 300 when failure count is fixed
    isFlexible: true,
    justifyEnd: false,
    withoutBorder: true
  },
  {
    id: 'actions',
    field: 'actions',
    headerName: '',
    justifyEnd: true,
    renderCell: params => <JobObjectStageFailureActions failure={params.row.data} />,
    width: 200
  }
];
